<template>
  <div class="info-page">
    <section class="info-page-section">
      <div class="ui-wrapper">
        <h2 class="section-title info-page-section__title">
          {{ $t('components.info.aboutPage.title') }}
        </h2>

        <div class="info-page-section__subtitle">
          {{ $t('components.info.aboutPage.subtitle') }}
        </div>
      </div>
    </section>

    <HomeOldBuy />
    <HomeOldExamination />
    <HomeOldStartSelling />
    <HomeOldServiceWork />
    <HomeOldCommunity />
    <HomeOldFourBlocks />
    <HomeOldAboutMedia />
  </div>
</template>

<script lang="ts" setup>
useHead({
  title: 'О проекте – Интернет-магазин Oskelly',
  meta: [
    {
      name: 'description',
      content: 'О проекте – Интернет-магазин Oskelly',
    },
  ],
  script: [
    {
      type: 'application/ld+json',
      children: `{
        "@context": "http://www.schema.org",
        "@type": "LocalBusiness",
        "name": "Oskelly Group",
        "url": "https://oskelly.ru/",
        "logo": "https://static.oskelly.ru/images/icons/insta_logo.png?v=2.1.2_c0753d93593d6441d0dd4f9eaecf0d8f",
        "image": "https://static.oskelly.ru/images/icons/insta_img_1.jpg?v=2.1.2_0a83dbe2155b3a0373b2dc3eb9a5a5ba",
        "description": "Первый сервис для покупки и перепродажи брендовых вещей в России. Бутики и частные продавцы размещают у нас новую и почти новую брендовую одежду со скидками до -90%.\n\nКаждый день мы добавляем 100+ новых товаров, а наши эксперты собирают лучшие из них в специальные подборки.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Варшавское шоссе, 9с28",
          "postOfficeBoxNumber": "info@oskelly.ru",
          "addressLocality": "Москва",
          "addressRegion": "Москва",
          "postalCode": "117105",
          "addressCountry": "Россия"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "55.737054",
          "longitude": "37.563080"
        },
        "hasMap": "https://goo.gl/maps/x94wA7cnGmzmkt4v9",
        "openingHours": "Mo, Tu, We, Th, Fr, Sa, Su -",
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "8 (800) 707-53-08",
          "contactType": "shop"
        }
      }`,
    },
  ],
});
</script>

<style scoped lang="scss">
.info-page-section {
  padding-top: 55px;
  padding-bottom: 50px;

  @media screen and (min-width: 767px) {
    padding-top: 24px;
    padding-bottom: 70px;
  }

  &__title {
    text-align: center;
    margin-bottom: 12px;

    @media screen and (min-width: 767px) {
      margin-bottom: 16px;
    }
  }

  &__subtitle {
    display: block;
    max-width: 560px;
    margin: 0 auto;
    color: #828282;
    text-align: center;
    font-size: 12px;
    line-height: 18px;

    @media screen and (min-width: 767px) {
      font-size: 14px;
      line-height: 22px;
    }
  }
}
</style>
